module.exports = __webpack_public_path__ + "img/Best Practices_Maria Bianca Louise Villacorta.9001885a.jpg";